"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GIFTCARD_FLOWS", {
    enumerable: true,
    get: ()=>GIFTCARD_FLOWS
});
var GIFTCARD_FLOWS;
(function(GIFTCARD_FLOWS) {
    GIFTCARD_FLOWS["null"] = 'NULL';
    GIFTCARD_FLOWS["addGiftCard"] = 'ADD_GIFT_CARD';
    GIFTCARD_FLOWS["existingGiftCard"] = 'EXISTING_GIFT_CARD';
    GIFTCARD_FLOWS["addPayment"] = 'ADD_PAYMENT';
    GIFTCARD_FLOWS["addPaymentCard"] = 'ADD_PAYMENT_CARD';
    GIFTCARD_FLOWS["addPaymentBank"] = 'ADD_PAYMENT_BANK';
    GIFTCARD_FLOWS["addFunds"] = 'ADD_FUNDS';
    GIFTCARD_FLOWS["convertPointsToCash"] = 'CONVERT_POINTS_TO_CASH';
    GIFTCARD_FLOWS["sendGiftCard"] = 'SEND_GIFT_CARD';
    GIFTCARD_FLOWS["sentGift"] = 'SENT_GIFT';
    GIFTCARD_FLOWS["managePayment"] = 'MANAGE_PAYMENT';
})(GIFTCARD_FLOWS || (GIFTCARD_FLOWS = {}));
